import PubSub from 'pubsub-js';

export const CLOSE_TICKET_CHECK_MODALS_ID = Symbol('7T:TicketCheck.CloseModals');

export const closeTicketCheckModalsEventPubSub:
PubSubJS.Base<{ reason: string }, typeof CLOSE_TICKET_CHECK_MODALS_ID> = PubSub;
